import { createApi } from '@reduxjs/toolkit/query/react'

import {
  getBaseQueryWithMockError,
  getCustomFetch,
} from '@/shared/api/custom-fetch-base'
import { IMarketplace } from '@/shared/types/data'

const mock = [
  {
    id: 1,
    name: 'ozon',
    label: 'Ozon',
    icon: '/icons/ozon.png',
  },
  {
    id: 2,
    name: 'wildberries',
    label: 'Wildberries',
    icon: '/icons/wb.png',
  },
  {
    id: 3,
    name: 'yandex-market',
    label: 'Яндекс Маркет',
    icon: '/icons/ym.png',
  },
]

export const marketplaceApi = createApi({
  reducerPath: 'marketplaceApi',
  baseQuery: getCustomFetch(),
  tagTypes: ['marketplace'],
  endpoints: build => ({
    marketplaceList: build.query<IMarketplace[], void>({
      query: () => ({
        url: '/marketplaces/',
        method: 'GET',
      }),
      providesTags: ['marketplace'],
    }),
  }),
})

export const { useMarketplaceListQuery } = marketplaceApi
